module.exports = __webpack_public_path__ + "static/media/Lonely Struggle - Ch 30 and Epilogue - English translated by JL.3ee5bb18.txt";